
export const fetchConfig = async () => {
  try {
    const res = await fetch('/ecpp/frontend-settings')
    const data = await res.json();
    return data.web
  } catch (e) {
    console.error('Error fetching env:', e);
  }
}
